const Index = () => import('./views/index.vue');

export default [
  {
    name: 'index',
    path: '/index',
    component: Index,
    meta: { title: '风变课灵小馆' }
  }
];
